import React from "react";
import wslogo from '../assets/whatsapplogo-gold.svg';
import wslogomobile from '../assets/whatsapplogo-goldbg.png';

const Home = () => {
  return (
    <div className="home-page">
      <div className="home-hero">
        <h1 className="home-hero-line home-hero-line--white">
          CREANDO SOLUCIONES TECNOLÓGICAS
        </h1>
        <h1 className="home-hero-line home-hero-line--gold">
          A MEDIDA<span className="blinking-cursor">I</span>
        </h1>
      </div>
      <div className="footer-container">
        <a href="https://wa.me/56996269600" rel="noreferrer" target="_blank">
          <img className="logo-whatsapp" src={wslogo} alt="Logo Whatsapp" />
          <img className="logo-whatsapp-mobile" src={wslogomobile} alt="Logo Whatsapp" />
        </a>
        <p className="copyright">© Photography by <a href="https://www.linkedin.com/in/umuty1/">Umut Yurdakök</a>. Lago Caburgua, Chile</p>
      </div>
    </div>
  );
};

export default Home;
